import * as React from 'react';

const Backspace: React.FC = () => (
    <svg className="icon" viewBox="0 0 100 100">
        <path
            d="M15.7,50l22.4,21.6h49V28.4h-49L15.7,50L15.7,50z M63.6,50.9l8-8l-4.4-4.4l-8,8l-8-8l-4.4,4.4l8,8L47.8,58
        l4.4,4.4l7.1-7.1l7.1,7.1l4.4-4.4L63.6,50.9L63.6,50.9z M35.6,22.2h57.7v55.6H35.6L6.8,50L35.6,22.2z"
        />
    </svg>
);

export default Backspace;
